module.exports = __webpack_public_path__ + "img/customer.b6168d0c.svg";